<template>
  <div class="repair-complaint-container">
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="bg-white index-1-left-item">
          <div class="index-title">
            <span>费用收入占比</span>
          </div>
          <div id="repairCount" style="height: 250px"></div>
          <div class="flex justify-between text-center stats-container">
            <div v-for="(item, index) in repairStats" :key="index">
              <div class="index-bottom-number">{{ item.value }}</div>
              <div class="index-bottom-number-desc">
                {{ $t(`propertyIndex.${item.label}`) }}
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="bg-white index-1-left-item">
          <div class="index-title">
            <span>房间状态统计</span>
          </div>
          <div id="complaintCount" style="height: 250px"></div>
          <!-- 状态明细展示区域 -->
          <div class="flex justify-between text-center stats-container">
            <div
              v-for="(item, key) in complaintStateDetail"
              :key="key"
              class="state-item"
            >
              <div class="index-bottom-number">{{ item.count }}</div>
              <div class="index-bottom-number-desc">
                {{ item.name }}
              </div>
            </div>
            <!-- 无数据提示 -->
            <div
              v-if="Object.keys(complaintStateDetail).length === 0"
              class="no-data"
            >
              {{ $t("propertyIndex.noData") }}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "IndexRepairComplaint",
  // 从父组件接收状态映射表和维修数据
  props: {
    roomStateMap: {
      type: Object,
      required: true, // 强制要求父组件传递
      default: () => ({}),
    },
    complaintData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      indexRepairComplaintInfo: {
        allCount: 0,
        waitCount: 0,
        doingCount: 0,
        finishCount: 0,
        allComplaintCount: 0,
        waitComplaintCount: 0,
        finishComplaintCount: 0,
        complaintStateDetail: {},
        complaintBuildingDetail: {},
      },
      repairChart: null,
      complaintChart: null,
      stateColors: {
        租赁中: "#01C36D",
        未销售: "#4B7AF0",
        已交房: "#FF7D00",
        未入住: "#F53F3F",
        已装修: "#86909C",
        已售: "#722ED1",
        空置中: "#EB0AA4",
        装修中: "#FF5722",
        借用中: "#FAAD14",
        免租期: "#0FC6C2",
        未知状态: "#86909C", // 新增未知状态默认颜色
      },
      isDataLoaded: false, // 标记数据是否已加载
    };
  },
  computed: {
    repairStats() {
      return [
        { label: "allRepair", value: this.indexRepairComplaintInfo.allCount },
        {
          label: "toBeDispatched",
          value: this.indexRepairComplaintInfo.waitCount,
        },
        {
          label: "processing",
          value: this.indexRepairComplaintInfo.doingCount,
        },
        {
          label: "processed",
          value: this.indexRepairComplaintInfo.finishCount,
        },
      ];
    },
    complaintStateDetail() {
      return this.indexRepairComplaintInfo.complaintStateDetail;
    },
    buildingList() {
      return Object.keys(this.indexRepairComplaintInfo.complaintBuildingDetail);
    },
    stateList() {
      const states = new Set();
      this.buildingList.forEach((building) => {
        Object.keys(
          this.indexRepairComplaintInfo.complaintBuildingDetail[building]
        ).forEach((state) => {
          states.add(state);
        });
      });
      return Array.from(states);
    },
  },
  watch: {
    // 监听父组件传递的维修数据变化
    complaintData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          console.log("从父组件接收最新维修数据:", newVal);
          this.processRepairData(newVal);
        }
      },
      immediate: true, // 初始化时立即处理
    },
    // 监听状态映射表变化
    roomStateMap: {
      handler(newVal) {
        console.log("从父组件接收最新状态映射:", newVal);
        // 若数据已加载，重新处理状态数据
        if (this.isDataLoaded) {
          this.processFjzttjData(this.complaintData.fjzttj || {});
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // 初始化图表尺寸监听
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    this.repairChart && this.repairChart.dispose();
    this.complaintChart && this.complaintChart.dispose();
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 处理父组件传递的维修数据
    processRepairData(repairData) {
      try {
        const fjzttj = repairData.fjzttj || {};
        this.processFjzttjData(fjzttj);
        // 合并其他统计数据
        Object.assign(this.indexRepairComplaintInfo, {
          allCount: repairData.allCount || 0,
          waitCount: repairData.waitCount || 0,
          doingCount: repairData.doingCount || 0,
          finishCount: repairData.finishCount || 0,
          allComplaintCount: repairData.allComplaintCount || 0,
          waitComplaintCount: repairData.waitComplaintCount || 0,
          finishComplaintCount: repairData.finishComplaintCount || 0,
        });
        this.isDataLoaded = true;
      } catch (error) {
        console.error("处理维修数据失败:", error);
      }
    },

    handleResize() {
      this.repairChart && this.repairChart.resize();
      this.complaintChart && this.complaintChart.resize();
    },

    processFjzttjData(fjzttj) {
      let allComplaintCount = 0;
      let waitComplaintCount = 0;
      let finishComplaintCount = 0;
      const complaintBuildingDetail = {};
      const complaintStateDetail = {};

      // 验证fjzttj数据格式
      if (typeof fjzttj !== "object" || fjzttj === null) {
        console.warn("fjzttj数据格式不正确，已初始化为空");
        this.updateComplaintData({
          allComplaintCount,
          waitComplaintCount,
          finishComplaintCount,
          complaintBuildingDetail,
          complaintStateDetail,
        });
        return;
      }

      const buildingKeys = Object.keys(fjzttj);
      if (buildingKeys.length === 0) {
        console.log("没有找到楼栋数据");
      }

      // 遍历楼栋处理数据
      buildingKeys.forEach((buildingKey) => {
        const stateObj = fjzttj[buildingKey];
        if (typeof stateObj !== "object" || stateObj === null) return;

        complaintBuildingDetail[buildingKey] = {};

        // 遍历状态统计数据
        Object.keys(stateObj).forEach((stateKey) => {
          const count = Number(stateObj[stateKey]) || 0;
          // 使用父组件传递的状态映射获取名称（未知状态兜底）
          const stateName =
            this.roomStateMap[stateKey] || `未知状态(${stateKey})`;

          // 累加总投诉数
          allComplaintCount += count;

          // 分类统计：待处理vs已处理
          const pendingStates = ["2002", "2004", "2008"]; // 未销售、未入住、空置中
          const completedStates = [
            "2001",
            "2003",
            "2005",
            "2006",
            "2007",
            "2009",
            "2010",
            "2011",
          ];

          if (pendingStates.includes(stateKey)) {
            waitComplaintCount += count;
          } else if (completedStates.includes(stateKey)) {
            finishComplaintCount += count;
          }

          // 按楼栋记录状态数据
          complaintBuildingDetail[buildingKey][stateName] =
            (complaintBuildingDetail[buildingKey][stateName] || 0) + count;

          // 按状态汇总明细数据
          if (complaintStateDetail[stateKey]) {
            complaintStateDetail[stateKey].count += count;
          } else {
            complaintStateDetail[stateKey] = {
              name: stateName,
              count: count,
            };
          }
        });
      });

      // 更新投诉数据并初始化图表
      this.updateComplaintData({
        allComplaintCount,
        waitComplaintCount,
        finishComplaintCount,
        complaintBuildingDetail,
        complaintStateDetail,
      });
    },

    updateComplaintData(data) {
      this.indexRepairComplaintInfo = {
        ...this.indexRepairComplaintInfo,
        ...data,
      };

      console.log(
        "更新后的状态明细数据:",
        this.indexRepairComplaintInfo.complaintStateDetail
      );

      this.$nextTick(() => {
        this.initComplaintChart();
        this.initRepairChart(); // 补充费用收入占比图表初始化
      });
    },

    // 初始化费用收入占比图表（补充完整方法）
    initRepairChart() {
      const dom = document.getElementById("repairCount");
      if (!dom) return;

      this.repairChart && this.repairChart.dispose();
      this.repairChart = echarts.init(dom);

      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "horizontal",
          bottom: 0,
          textStyle: { fontSize: 12 },
        },
        series: [
          {
            name: "费用类型",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: this.indexRepairComplaintInfo.waitCount,
                name: this.$t("propertyIndex.toBeDispatched"),
              },
              {
                value: this.indexRepairComplaintInfo.doingCount,
                name: this.$t("propertyIndex.processing"),
              },
              {
                value: this.indexRepairComplaintInfo.finishCount,
                name: this.$t("propertyIndex.processed"),
              },
            ],
          },
        ],
      };

      this.repairChart.setOption(option);
    },

    initComplaintChart() {
      const dom = document.getElementById("complaintCount");
      if (!dom) return;

      this.complaintChart && this.complaintChart.dispose();
      this.complaintChart = echarts.init(dom);

      // 生成多柱状图数据
      const series = this.stateList.map((state) => ({
        name: state,
        type: "bar",
        data: this.buildingList.map((building) => {
          return (
            this.indexRepairComplaintInfo.complaintBuildingDetail[building][
              state
            ] || 0
          );
        }),
        itemStyle: {
          color: this.stateColors[state] || this.stateColors["未知状态"],
        },
      }));

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: (params) => {
            let result = `${params[0].name}<br/>`;
            params.forEach((item) => {
              result += `${item.seriesName}: ${item.value} 条<br/>`;
            });
            return result;
          },
        },
        legend: {
          data: this.stateList,
          top: "2%",
          left: "center",
          textStyle: { fontSize: 12 },
        },
        grid: {
          left: "3%",
          top: "15%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.buildingList.map((building) => `${building}号栋 `),
          axisLabel: { fontSize: 12 },
        },
        yAxis: {
          type: "value",
          minInterval: 1, // 确保Y轴是整数
        },
        series: series,
        barWidth: 20,
      };

      this.complaintChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.index-1-left-item {
  background: #fff;
  border-radius: 4px;
  padding: 15px;

  .index-title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }

  .stats-container {
    padding-top: 15px;
    border-top: 1px solid #eee;

    .state-item {
      min-width: 80px;
      margin: 0 5px 10px;
    }

    .index-bottom-number {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }

    .index-bottom-number-desc {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .no-data {
      color: #999;
      padding: 10px;
      width: 100%;
    }
  }
}
</style>
